"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.eq = void 0;
const config_1 = require("../config");
const eq = ({ leftValue, rightValue, }) => {
    // Return array which matches length of left value
    if (Array.isArray(leftValue) && typeof rightValue === 'number') {
        const result = [];
        // eslint-disable-next-line no-restricted-syntax
        for (let idx = 0; idx < leftValue.length; idx += 1) {
            const leftElement = leftValue[idx];
            result.push(leftElement === rightValue);
        }
        return {
            error: null,
            result,
        };
    }
    // Return array which matches length of right value
    if (typeof leftValue === 'number' && Array.isArray(rightValue)) {
        const result = [];
        // eslint-disable-next-line no-restricted-syntax
        for (let idx = 0; idx < rightValue.length; idx += 1) {
            const rightElement = rightValue[idx];
            result.push(leftValue === rightElement);
        }
        return {
            error: null,
            result,
        };
    }
    // Validate array lengths match
    if (Array.isArray(leftValue) && Array.isArray(rightValue)) {
        if (leftValue.length !== rightValue.length) {
            return {
                error: `Comparison error: array inputs must have the same length`,
            };
        }
        const result = [];
        // eslint-disable-next-line no-restricted-syntax
        for (let idx = 0; idx < leftValue.length; idx += 1) {
            const leftElement = leftValue[idx];
            const rightElement = rightValue[idx];
            result.push(leftElement === rightElement);
        }
        return {
            error: null,
            result,
        };
    }
    // Strict check for string types prior to handling case insensitive matches
    // Case insensitivity to match hyperformula settings
    if (typeof leftValue === 'string' &&
        typeof rightValue === 'string' &&
        !config_1.config.CASE_SENSITIVE) {
        const result = leftValue.toLowerCase() === rightValue.toLowerCase();
        return { error: null, result };
    }
    // Default fallback
    const result = leftValue === rightValue;
    return { error: null, result };
};
exports.eq = eq;
//# sourceMappingURL=eq.js.map